import { render, staticRenderFns } from "./UnderwriterList.vue?vue&type=template&id=0e84c9e6&"
import script from "./UnderwriterList.vue?vue&type=script&lang=js&"
export * from "./UnderwriterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports